export default __webpack_public_path__ + "static/media/freitag.8a30bdb4.svg";